const QUOTE_HEADER_RE = [
  /Op .{5,100}? heeft [\s\S]{1,400}? het volgende geschreven:\s*/i,
  /\nOn .{8,160}? wrote:\s*/i,
  /\nOp .{8,160}? schreef\s+/i,
  /\n-----Original Message-----/i,
  /\nFrom: .+\nSent:/i,
  /\nVan: .+\nVerzonden:/i,
];

function decodeEntities(text) {
  return String(text || '')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&nbsp;/g, ' ')
    .replace(/&#39;/g, "'")
    .replace(/&quot;/g, '"');
}

function htmlToPlain(html) {
  return decodeEntities(
    String(html || '')
      .replace(/<style[\s\S]*?<\/style>/gi, ' ')
      .replace(/<head[\s\S]*?<\/head>/gi, ' ')
      .replace(/<div class="gmail_quote[\s\S]*$/i, '')
      .replace(/<blockquote[\s\S]*$/i, '')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<[^>]+>/g, ' ')
      .replace(/\.[a-z][\w-]*\s*\{[^}]*\}/gi, ' ')
  );
}

function stripQuotedOriginal(text) {
  let result = decodeEntities(String(text || ''))
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n');
  for (const splitter of QUOTE_HEADER_RE) {
    result = result.split(splitter)[0];
  }
  return result.replace(/[ \t]+\n/g, '\n').trim();
}

export function quotedReplyPlaintext(bodyText, bodyHtml) {
  let excerpt = stripQuotedOriginal(bodyText);
  if (!excerpt && bodyHtml) {
    excerpt = stripQuotedOriginal(htmlToPlain(bodyHtml));
  }
  return excerpt.trim();
}
